import { ActiveLanguage, HTMLHelper } from 'shared/vidio_helpers';
import AhoyEvent from 'shared/ahoy_event';

export default class ProfileCompletingAgeGenderModal {
  constructor(currentUser) {
    this.currentUser = currentUser;
  }

  init() {
    this.renderModal();
    this.initElements();
    this.bindSubmitButton();

    if(!this.currentUser.has_content_preferences) {
      this.bindAjaxSuccess();
    };
  }

  renderModal() {
    HTMLHelper.appendCode(document.querySelector('body'), this.getView());
  }

  getView() {
    const locale = window.Locale[ ActiveLanguage.get() ].content_gating_banner;

    return `
      <div class="age-gender-modal js-age-gender-modal hide">
        <div class="age-gender-modal__overlay">
        </div>
        <section class="age-gender-modal__section">
          <div class="age-gender-modal__title">${locale.age_gender.modal_title}</div>
          <div class="age-gender-modal__description">${locale.age_gender.modal_description}</div>
          <form action="/users/${this.currentUser.username}/age_gender" class="age-gender-modal__form" method="POST" data-remote="true">
            <div class="age-gender-modal__form-item">
              <input class="age-gender-modal__form-input age-gender-modal__form-input--display-name" type="text" name="user[display_name]" required="required" placeholder="${locale.age_gender.name}" maxlength="32">
            </div>
            <div class="age-gender-modal__form-item age-gender-modal__form-item--year">
              <select class="age-gender-modal__form-input age-gender-modal__form-input--age" name="user[year_of_birth]" required="required">
                <option disabled="disabled" selected="selected" value="">${locale.age_gender.yob}</option>
                ${this.getYearOptions()}
              </select>
            </div>
            <div class="age-gender-modal__form-item age-gender-modal__form-item--gender">
              <input type="radio" name="user[gender]" id="user_gender_male" value="male" class="age-gender-modal__gender-radio age-gender-modal__gender-radio--male" required="required">
              <label class="age-gender-modal__gender-label age-gender-modal__gender-label--male" for="user_gender_male">
                <div class="blue-radio-button">
                  <div class="blue-radio-button__checkmark"></div>
                </div>
                ${locale.account_settings.male}
              </label>
              <input type="radio" name="user[gender]" id="user_gender_female" value="female" class="age-gender-modal__gender-radio age-gender-modal__gender-radio--female" required="required">
              <label class="age-gender-modal__gender-label age-gender-modal__gender-label--female" for="user_gender_female">
                <div class="blue-radio-button">
                  <div class="blue-radio-button__checkmark"></div>
                </div>
                ${locale.account_settings.female}
              </label>
            </div>
            <input type="hidden" name="authenticity_token" id="authenticity_token" class="js-age-gender-modal__input-csrf" value="${this.currentUser.token}">
            <div class="age-gender-modal__form-error hide"></div>
            <button type="submit" class="age-gender-modal__form-button js-age-gender-modal__form-button" data-disable_with="Processing..">${locale.age_gender.continue_button}</button>
          </form>
        </section>
      </div>
    `;
  }

  initElements() {
    this.ageGenderFormModal = document.querySelector('.js-age-gender-modal');
    this.form = document.querySelector('form.age-gender-modal__form');
    this.submitButton = document.querySelector('button.js-age-gender-modal__form-button');
  }


  getCurrentYear() {
    return (new Date()).getFullYear();
  }

  getYearOptions() {
    const currentYear = this.getCurrentYear();
    let options = '';
    for (let year = currentYear - 13; year >= currentYear - 80; year--) {
      options += `
        <option value="${year}">${year}</option>
      `;
    }
    return options;
  }

  bindSubmitButton() {
    this.submitButton.addEventListener('click', () => {
      AhoyEvent.send('VIDIO::ONBOARDING', {
        action: 'continue',
        feature: 'profile completing'
      });
    });
  }

  bindAjaxSuccess() {
    this.form.addEventListener('ajax:success', this._redirectToContentPreferencesPage);
  }

  _redirectToContentPreferencesPage() {
    window.location.href = '/content_preferences';
  }

  show() {
    this.ageGenderFormModal.classList.remove('hide');
    AhoyEvent.send('VIDIO::ONBOARDING', {
      action: 'impression',
      feature: 'profile completing'
    });
  }
}
